import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useAddAppointmentConfigurationService = (
  serviceId,
  options = {},
) => {
  const res = useMutation(
    async (dto) => http.post(HTTP_ENDPOINTS.createService(serviceId), dto),
    { ...options },
  );
  return res;
};
